"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Errors = void 0;
var react_1 = __importDefault(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
var storybook_1 = require("@eyecons/storybook");
var Errors = function (_a) {
    var errors = _a.errors;
    return react_1.default.createElement(storybook_1.Forms.Error, null, errors.map(function (error, index) { return react_1.default.createElement(storybook_1.Texts.Danger, { key: index }, error.message); }));
};
exports.Errors = Errors;
exports.Errors.propTypes = {
    /**
     * The Errors.
     */
    errors: prop_types_1.default.array,
};
exports.Errors.defaultProps = {
    errors: [],
};
